import React, { type ComponentProps } from 'react';

import { cn } from '@/clientOnlyUtils/cn';

import styles from './ContentSection.module.scss';

type ContentSectionProps = Omit<ComponentProps<'div'>, 'size'> & {
  size?: 'small';
};

export const ContentSection = ({ children, size, className, ...props }: ContentSectionProps) => (
  <div
    className={cn('flex flex-col gap-2', styles.container, className, size === 'small' ? styles.small : undefined)}
    {...props}>
    {children}
  </div>
);
